<template>
  <v-navigation-drawer
    :value="isSidebarSendActive"
    temporary
    touchless
    :right="!$vuetify.rtl"
    width="350"
    app
    @input="val => $emit('update:is-sidebar-send-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center">
        <h4 class="font-weight-semibold text-base">
          {{ $t('btn.gestionarCobros') }}
        </h4>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:is-sidebar-send-active', false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="clientCarShop.email"
                outlined
                :label="$t('lbl.para')"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="clientCarShop.subject"
                outlined
                :label="$t('lbl.subject')"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <!--<v-textarea
                v-model="clientCarShop.message"
                outlined
                :label="$t('lbl.message')"
                rows="11"
                hide-details="auto"
                class="mb-6"
              >
              </v-textarea>-->
              <tiptap-vuetify
                v-model="clientCarShop.message"
                :extensions="extensions"
                :placeholder="`${$t('lbl.message')}...`"
              />
            </v-col>
          </v-row>

          <!--<v-chip
            color="primary"
            small
            label
            class="v-chip-light-bg primary--text mb-6"
          >
            {{ $t('lbl.adjuntCotization') }}
          </v-chip>-->

          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="error"
                block
                @click="$emit('update:is-sidebar-send-active', false)"
              >
                {{ $t('btn.cancele') }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="primary"
                outlined
                block
                :disabled="!clientCarShop.email || !clientCarShop.subject || !clientCarShop.message"
                :loading="loading"
                @click="sendEmail"
              >
                {{ $t('btn.send') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { mdiClose } from '@mdi/js'
import {
  TiptapVuetify,
  Bold,
  Italic,

  // BulletList,
  // OrderedList,
  // ListItem,
  HardBreak /* Paragraph, Strike, Heading, Underline, Code, BulletList, OrderedList, ListItem, Link, Blockquote, HorizontalRule, History, */,
} from 'tiptap-vuetify'

export default {
  components: {
    TiptapVuetify,
  },
  model: {
    prop: 'isSidebarSendActive',
    event: 'update:is-sidebar-send-active',
  },
  props: {
    isSidebarSendActive: {
      type: Boolean,
      required: true,
    },
    from: {
      type: String,
      required: true,
    },
    nameb2b: {
      type: String,
      required: true,
    },
    nameafiliado: {
      type: String,
      required: true,
    },
    codes: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    user: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      extensions: [
        // BulletList,
        // OrderedList,
        // ListItem,
        Italic,
        Bold,
        HardBreak,
      ],
      icons: {
        mdiClose,
      },
    }
  },
  computed: {
    ...mapState({
      clientCarShop: state => state.app.clientCarShop,
      loadingBtn: state => state.app.loadingBtn,
      carItems: state => state.app.carItems,
    }),
    message: {
      get() {
        const msg = `<p>Estimados colegas de ${this.nameafiliado},
          <br /><br />
Nuestro equipo se complace en saludarle. Nos comunicamos con ustedes para recordarles que tiene cuentas por pagar en nuestro sistema:
<br />
${this.codes}<br /><br />
Por favor, acceda con su usuario y contraseña al módulo de Gestión en el dashboard del B2B para completar estos pagos.
<br /><br />
Le acompañamos en su gestión para que su negocio crezca.
<br /><br />
Atentamente,<br />
Equipo de gestión<br />
<b>${this.nameb2b}</b>
</p>
`

        return msg
      },
    },
  },

  created() {
    this.clientCarShop.subject = 'Gestión de cobros, cuentas por pagar'
    this.clientCarShop.message = this.message
  },
  methods: {
    ...mapMutations(['setCheckAllCobros', 'updateItemCheckCobros']),
    sendEmail() {
      const json = {
        subject: this.clientCarShop.subject,
        message: this.clientCarShop.message,
        email: this.clientCarShop.email,
      }
      this.loading = true
      this.axios
        .post('ctas-x-cobrar/send-email', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          // eslint-disable-next-line no-empty
          if (res.data.success === true) {
            this.$emit('update:is-sidebar-send-active', false)
            this.$toast.success(this.$t('msg.infoSuccess'))

            // VACIAR EL ARREGLO
            this.setCheckAllCobros(false)
            this.updateItemCheckCobros([])
            this.$emit('update:is-sidebar-data-pays-active', false)
            this.$emit('initAll')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
